import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-teal-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-teal-500 rounded-full flex items-center justify-center">
                <i className="fas fa-balance-scale text-white text-lg"></i>
              </div>
              <span className="text-lg font-bold">{t('officeName')}</span>
            </div>
            <p className="text-sm text-teal-200 leading-relaxed">
              {t('tagline')}
            </p>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-base">{t('servicesTitle')}</h3>
            <ul className="space-y-2 text-sm text-teal-200">
              <li><a href="#services" className="hover:text-white transition-colors">{t('service1')}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t('service2')}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t('service3')}</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">{t('service4')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-base">{t('officeInfoTitle')}</h3>
            <ul className="space-y-2 text-sm text-teal-200">
              <li><a href="#pricing" className="hover:text-white transition-colors">{t('pricing')}</a></li>
              <li><a href="#testimonials" className="hover:text-white transition-colors">{t('testimonials')}</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">{t('faq')}</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">{t('contact')}</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-4 text-base">{t('contactTitle')}</h3>
            <ul className="space-y-3 text-sm text-teal-200">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-400 mt-1"></i>
                <span>東京都新宿区水道町3-14<br />神楽坂Nビル 2-M</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-teal-400"></i>
                <a href="tel:05036352288" className="hover:text-white transition-colors">050-3635-2288</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-400"></i>
                <a href="mailto:Jzhou6205@gmail.com" className="hover:text-white transition-colors break-all">Jzhou6205@gmail.com</a>
              </li>
              <li className="flex items-start gap-2 mt-3">
                <i className="ri-wechat-line text-teal-400 mt-1"></i>
                <div>
                  <p className="mb-2">WeChat</p>
                  <div className="w-24 h-24 rounded-md overflow-hidden border-2 border-teal-500">
                    <img
                      src="https://static.readdy.ai/image/fa61325f1bcb10e63a715068dd996489/3634758164264d67e338f6c008744b84.jpeg"
                      alt="WeChat QR Code"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-teal-300">{t('copyright')}</p>
          <a href="https://readdy.ai/?ref=logo" className="text-sm text-teal-400 hover:text-white transition-colors">
            {t('poweredBy')}
          </a>
        </div>
      </div>
    </footer>
  );
}
